

import { Component, OnInit, Input, HostListener } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { DataService } from '../../service/data.service';
import { AppService } from '../../service/app.service';



@Component({
  selector: 'app-barq-component',
  templateUrl: './barq-component.component.html',
  styleUrls: ['./barq-component.component.scss'],
})
export class BarqComponentComponent implements OnInit {

  @HostListener('document:keypress', ['$event'])
  onKeyUp(ev: KeyboardEvent) {
    if (ev.target['name'] !== 'remarkField') {
      this.getValue(ev.key);
      let input: any = document.querySelector(".my-input");
      input.focus();
    }
  }

  @Input() activeAmount: string;
  progressState = 1;
  amount: any;
  barqValue = '';
  success = false;
  succesLottie: any = {
    path: 'assets/lotties/success.json',
    renderer: 'canvas',
    autoplay: true,
    loop: false
  };
  failLottie: any = {
    path: 'assets/lotties/fail.json',
    renderer: 'canvas',
    autoplay: true,
    loop: false
  };
  remark: string;

  constructor(private navParams: NavParams,
    public dataService: DataService,
    public appService: AppService) { }

  ngOnInit() {
    this.amount = parseFloat(this.activeAmount);
  }


  /**
   * @method { method will get the value from barcode }
   * @param {*} key
   */
  getValue(key) {
    if (key !== 'Enter') {
      this.barqValue += key;
    } else {
      this.initBarqTransaction();
    }
  }



  /**
  * @method { method will initiate the transaction using barq }
  */
  initBarqTransaction() {
    this.progressState = 2;
    this.success = false;
    let params = {
      token: parseInt(this.barqValue),
      amount: this.amount,
      remarks: this.remark
    };

    this.dataService.barqTransaction(params).subscribe((res: any) => {
      this.successTrnsaction();
    }, (err) => {
      this.failedTransaction(err);
    });
  }


  /**
  * @method { method will manage state in success transaction }
  */
  successTrnsaction() {
    setTimeout(() => {
      this.success = true;
      this.progressState = 3;
    }, 800);
  }


  /**
  * @method { method will manage state in fail transaction }
  */
  failedTransaction(err) {
    setTimeout(() => {
      this.success = false;
      this.progressState = 3;
      if (err.error.code === 4003) {
        this.appService.toastMessage('Token not found');
      } else {
        this.appService.toastMessage('Something wents wrong');
      }
    }, 800);
  }


  /**
   * @method { method will manage state to retry  }
  */
  retry() {
    this.barqValue = '';
    this.progressState = 1;
  }

  ngOnDestroy() {
    this.amount = null;
  }
}
